<style type="text/css">
.sidebar {
  background-color: #fff;
  color: #424242;
}

.sidebar .nav .nav-item .nav-link.active,
.sidebar .nav .nav-item .nav-link.active i {
  font-weight: 600;
  color: #424242;
  background-color: transparent;
}

.sidebar .nav .nav-item .nav-link i {
  width: 10px;
}

.sidebar .nav .nav-item.nav-dropdown.open>ul {
  /*padding-left: 30px;*/
  /*text-align: center;*/
  position: relative;
  left: 15px;
}

.sidebar .nav .nav-item.nav-dropdown.open {
  background-color: transparent;
}

.sidebar .nav .nav-item.nav-dropdown.open .nav-link .nav-dropdown-toggle {
  color: #20a8d8;
}

.sidebar .nav .nav-item.nav-dropdown.open .nav-dropdown-toggle {
  color: #20a8d 8;
}

.sidebar .nav .nav-item.nav-dropdown.open .nav-dropdown-toggle>.fa {
  color: #424242;
}

.sidebar .nav .nav-item.nav-dropdown.open .active {
  color: #424242 !important;
  background: #DEE9F1 !important;
}

.sidebar .nav .nav-item.nav-dropdown.open .active:hover {
  color: transparent;
}

.sidebar .sidebar-nav::-webkit-scrollbar-thumb {
  background-color: #c1c1c1;
}

.sidebar .sidebar-nav::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

li {
  border-bottom: 1px solid gray;
}

.sidebar .nav .nav-item>li {
  border-bottom: 1px solid transparent;
}

.sidebar-minimized .sidebar .nav .nav-item ul {
  background-color: #F3F2F1;
}

.nav-link .nav-dropdown-toggle:hover {
  color: #fff;
}

.sidebar {
  border-right: 1px solid #c2cfd6;
}

.sidebar .nav .nav-item .nav-link {
  padding: 0.28rem 0.25rem;
}

.sidebar .nav .nav-item .nav-link i {
  width: 30px;
  color: #262626;
  background-color: #bbc5d6;
  padding: 7px;
  border-radius: 6px;
  font-size: 12px;
}

.sidebar .nav .nav-item .nav-link.active i {
  width: 30px;
  color: #fff;
  background-color: #F68607;
  padding: 7px;
  border-radius: 6px;
  font-size: 12px;
}

.sidebar .nav .nav-item .nav-link.active:hover i {
  color: #fff;
}

.sidebar .nav .nav-item .nav-link:hover i {
  color: #424242;
}

li {
  border-bottom: 1px dotted #b6b7b8;
}

.sidebar .nav .nav-item .nav-link.nav-dropdown-toggle::before,
.sidebar .nav .nav-item .navbar .nav-dropdown-toggle.dropdown-toggle::before,
.navbar .sidebar .nav .nav-item .nav-dropdown-toggle.dropdown-toggle::before {
  font-size: 1.7rem;
  font-weight: 600;
  top: 0.8rem;
}

.sidebar .nav .nav-item.nav-dropdown.open>ul,
.sidebar .nav .nav-item.nav-dropdown.open>ol {
  width: 100%;
  font-size: 13px;

}

.sidebar .sidebar-nav::-webkit-scrollbar-track {
  border-left: 1px solid #b6b7b8;
}

.sidebar .nav .nav-item.nav-dropdown.open .nav-link {
  border-bottom: 1px dotted #b6b7b8;
}

.sidebar .nav .nav-item.nav-dropdown.open .nav-dropdown-toggle {
  background: #20a8d8;
  color: #fff;
}

.sidebar .nav .nav-item .nav-link:hover {
  background: #d2edf7;
  color: #424242;
}

.sidebar .nav .nav-item.nav-dropdown.open .active {
  color: #424242 !important;
  background: #DEE9F1 !important;
}

@media (min-width: 992px) {
  .sidebar-minimized.sidebar-fixed .sidebar {
    width: 0px;
  }

  .sidebar-minimized.sidebar-fixed .main,
  .sidebar-minimized.sidebar-fixed .app-footer {
    margin-left: 0px;
  }
}
</style>
<template>
<div class="sidebar">
  <nav class="sidebar-nav">
    <div slot="header"></div>
    <!--  <ul class="nav">

          <li class="nav-item" v-for="item in navItem">
            <template>
              <SidebarNavLink :name="item.mainmenu" :url="'../../'+item.mainmenu" :icon="item.purl"/>
            </template>
        </li>
      </ul> -->
    <ul class="nav">
      <li class="nav-item" v-for="(item, index) in navItem">

        <template v-if="item.children.length>0">
          <!-- <SidebarNavDropdown :name="item.name" :url="'../../'+item.url" :icon="item.purl"> -->
          <SidebarNavDropdown :name="item.name" :url="'../../../..'+item.url" :icon="item.icons">
            <template v-for="child in item.children">
              <!-- <SidebarNavLink :name="child.name"  :url="'../../'+child.url" :icon="child.purl"/> -->
              <SidebarNavLink :name="child.name" :url="'../../../..'+child.url" :icon="child.icons" />

            </template>
          </SidebarNavDropdown>
        </template>
        <template v-else>
          <!-- <SidebarNavLink :name="item.name" :icon="item.purl" :url="'../../'+item.url"/> -->
          <SidebarNavLink :name="item.name" :icon="item.icons" :url="'../../../..'+item.url" />
        </template>
      </li>
    </ul>
    <slot></slot>
    <div slot="footer"></div>
  </nav>
</div>
</template>
<script>
import SidebarNavDropdown from './SidebarNavDropdown';
import SidebarNavLink from './SidebarNavLink';
import SidebarNavTitle from './SidebarNavTitle';
import CryptoJS from 'crypto-js';
export default {
  name: 'sidebar',
  props: {

  },
  components: {
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle
  },

  data() {
    return {
      navItem: [],
      purl: 'fa fa-home',
    }
  },
  mounted() {
    var permissionEncrypt = window.localStorage.getItem('permissiondata')
    var isLoggedIn = window.localStorage.getItem('isLoggedIn');

    if (isLoggedIn == null) {
      isLoggedIn = false;
    } else {
      isLoggedIn = true;
    }

    if (permissionEncrypt == null || permissionEncrypt == undefined && !isLoggedIn) {
      this.$router.push({
        path: "/login",
      });
      return false
    }

    var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    this.navItem = JSON.parse(plaintext);
    //this.navItem=JSON.parse(window.localStorage.getItem('permissiondata'))
    //console.log(this.navItem)
    //this.leftjson = '[{"permission_name":"Dashboard","url":"home","role":"super admin","parentid":"1"},{"purl":"images/icons/5.png","permission_name":"Master Product List","url":"company","role":"super admin","parentid":"1"},{"purl":"images/icons/2.png","permission_name":"Merchant","url":"merchant","role":"super admin","parentid":"1"}]'
    //this.navItem = JSON.parse(this.leftjson)
    //,{"purl":"images/icons/1.png","permission_name":"Company","url":"company","role":"super admin","parentid":"1"}
  },

  methods: {
    handleClick(e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>

<style lang="css">
  .nav-link {
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue?1fd0fb55